/*
*   区域设置管理组件
*   zxw
*   2024-08-15
*/

import React , { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Row, Col, message, Table, Input, 
    Select, Modal, Button, Dropdown, Tag, } from 'antd';
import { DownOutlined, PlusOutlined,ExclamationCircleFilled } from '@ant-design/icons';
import { UjoinParams, AddRequestHeaders, winWidth,} from '../../incs/FunHelper.js';

import AreaEntity from './AreaEntity.js';

const Option = Select.Option;
const { TextArea } = Input;
const MODULENAME = '区域';

let root = null;

/**
 * 信息提示框组件
 * @param {*} props 
 * @returns 
 */
const InfoPromptModal = (props) => {
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const handleCancel = () =>{
        setDescription('');
        setOpen(false);
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
   const handleOK = () =>{
        $.ajax({
            url: `${CNF.api}setting/areas/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: props.action==='DELETE'?'DELETE':'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': props.action,
                'description': description
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1);
                }
                handleCancel();
            }
        })
    }

    return (
        <>
            <Modal
                okType='danger'
                title={<><ExclamationCircleFilled style={{ color: '#FAAD13' }} /> {MODULENAME}</>}
                closeIcon={false}
                open={open}
                onOk={()=>{handleOK()}}
                onCancel={()=>{handleCancel()}}
                okText='确认'
                cancelText='取消'
                okButtonProps={{disabled: description?false:true}}
            >
                <div>
                    <p style={{ marginTop: 0 }}>考虑清楚了？确定要{props.action==='DISABLE'?'禁用':props.action==='ACTIVE'?'激活':'删除'}该{MODULENAME}：{props.record.name}</p>
                    <TextArea
                        placeholder='必填字段，需要备注说明'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e)=>{setDescription(e.target.value)}}
                        value={description}
                    />
                </div>
            </Modal>
        </>
    );
}

class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }

    update = (record) =>{this.props.setIsModalOpen(true, record);}
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        switch(action){
            case 'update':
                this.update(record);
                break;
            case 'disable':
                this.showInfoPromptModal(record,'DISABLE');
                break;
            case 'active':
                this.showInfoPromptModal(record,'ACTIVE');
                break;
            case 'delete':
                this.showInfoPromptModal(record,'DELETE');
                break;
            default:
                break;
        }
    }

    /**
     * 显示提示框信息信息
     * @param {*} record 
     */
    showInfoPromptModal = (record, action) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('info-prompt-modal-id'));
        }
        root.render(
            <InfoPromptModal
                open={true}
                isRefresh={this.props.isRefresh}
                action={action}
                record={record}
            />
        );
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '区域名称',key: 'name',dataIndex: 'name',},
            {title: '大屏名称',key: 'dashboard_name',dataIndex: 'dashboard_name',},
            {title: '主题样式',key: 'theme_number',
                render: function(record){
                    if(record.theme_number){
                        return <Tag color={CNF.themes[parseInt(record.theme_number)-1].tbgColor}>{CNF.themes[parseInt(record.theme_number)-1].name}</Tag>
                    }else{
                        return <Tag color={CNF.themes[0].tbgColor}>{CNF.themes[0].name}</Tag>
                    }
                }
            },
            {title: '行政代码',key: 'adcode', dataIndex: 'adcode',},
            {title: '父级代码',key: 'parent_adcode', dataIndex: 'parent_adcode',},
            {title: '经度',key: 'longitude',
                render: function(record){
                    if(record.longitude){
                        return record.longitude
                    }else{
                        return '-'
                    }
                }
            },
            {title: '纬度',key: 'latitude',
                render: function(record){
                    if(record.latitude){
                        return record.latitude
                    }else{
                        return '-'
                    }
                }
            },
            {title: '开启定位',key: 'open_position',
                render: function(record){
                    return <Tag style={{ width:'60%',textAlign:'center' }} color='blue'>{record.open_position?'是':'否'}</Tag>
                }
            },
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time',width: 120,},
            {title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: 80,},
            {title: '状态', key: 'status', fixed: 'right',width: 60,
                render: function(record){
                    for(let item of CNF.status){
                        if(parseInt(record.status) === parseInt(item.value)){
                            return item.key
                        }
                    }
                }
            },
            {title: '', key: 'operation', fixed: 'right', width: 80,
                render: (record) => {
                    let items = [];
                    if(this.props.btnLists.indexOf('btn_teii_setting_area_update')>0){
                        items.push({key: '1', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('update', record)}}>修改</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_setting_area_update') >= 0 
                    && record.status.toString() === CNF.status[0].value.toString()){
                        items.push({key: '2', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('disable', record)}}>禁用</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_setting_area_update') >= 0 
                    && record.status.toString() === CNF.status[1].value.toString()){
                        items.push({key: '3', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('active', record)}}>激活</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_setting_area_delete')>=0){
                        items.push({key: '4', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('delete', record)}}>删除</Button>)})
                    }
                    return (
                        <Dropdown menu={{ items, }}>
                            <Button type='link' style={{ padding:0, height: 10,margin:0 }}>
                                    操作
                                    <DownOutlined />
                            </Button>
                        </Dropdown>
                    );
                }
            }
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    // scroll={{ x: winWidth}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component{
    constructor(props){
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            name: '',
            status: 1,
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeName = (e) =>{this.setState({name: e.target.value});this.search();}
    changeStatus = (value) =>{ this.setState({ status: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}
    setIsModalOpen = (value, record) =>{this.setState({isModalOpen: value, record: record});}
    create = () =>{this.setIsModalOpen(true, null);}

    /**
     * 获取列表
     */
    getLists(){
        const _this = this;
        const params = {
            'name': this.state.name,
            'status': this.state.status,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}setting/areas${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.getLists();
    }

    render(){
        return(
            <>
                <div>
                    <Row style={{ height: 60, paddingTop:10, paddingLeft:20}}>
                        <Col span={2}>
                            <Input
                                onChange={this.changeName}
                                onPressEnter={this.search}
                                placeholder='区域名称...'
                                value={this.state.name}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Select 
                                value={this.state.status}
                                style={{ width: '100%' }} 
                                onChange={this.changeStatus}
                            >
                                <Option value=''>状态</Option>
                                {
                                    CNF.status && CNF.status.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ lineHeight: 2.2,marginLeft: 10 }}>
                        {
                            this.props.btnLists.indexOf('btn_teii_setting_area_create') >=0 ? (
                                <>
                                    <Button 
                                        title={MODULENAME}
                                        type='link'
                                        icon={<PlusOutlined/>}
                                        onClick={() =>{
                                            this.create();
                                        }}>
                                    </Button>
                                </>):''
                            }
                        </Col>
                        <AreaEntity 
                            policy={this.props.policy}
                            isModalOpen={this.state.isModalOpen} 
                            record={this.state.record}
                            setIsModalOpen={this.setIsModalOpen} 
                            isRefresh={this.isRefresh}
                        />
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Lists
                                preGroup={this.props.preGroup}
                                btnLists={this.props.btnLists}
                                dataLists={this.state.dataLists} 
                                currentIndex={this.state.currentIndex}
                                pageCount={this.state.pageCount} 
                                changeIndex={this.changeIndex} 
                                setIsModalOpen={this.setIsModalOpen}
                                isRefresh={this.isRefresh}
                            />
                        </Col>
                    </Row>
                </div>
                <div id='info-prompt-modal-id'></div>
                <div id='show-info-id'></div>
            </>
        );
    }
}

export default CPT